import { publicInstance } from "apis";
import { useMutation } from "react-query";

const useCheckEmail = () => {
  const fetcher = async (userName: string) => {
    const { data } = await publicInstance.post("/user/checkEmail", {
      userName,
    });
    return data;
  };

  const { mutate } = useMutation(fetcher);

  return mutate;
};

export default useCheckEmail;
